import {
  Component,
  ElementRef,
  HostListener,
  Input,
  ViewChild,
} from '@angular/core';
import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';
import { CommonModule } from '@angular/common';
import { ScDatePipePipe } from 'src/app/core/pipes/sc-date-pipe.pipe';
import { QRCodeComponent } from 'angularx-qrcode';

@Component({
    selector: 'app-ticket-instance',
    templateUrl: './ticket-instance.component.html',
    styleUrls: ['./ticket-instance.component.scss'],
    imports: [CommonModule, ScDatePipePipe, QRCodeComponent]
})
export class TicketInstanceComponent {
  @Input('ticketToShow') ticketToShow: any;
  @Input('showDownload') showDownload: boolean = false;
  isMobile: boolean = false;
  @ViewChild('content', { read: ElementRef }) content: ElementRef | undefined;

  @HostListener('window:resize', ['$event'])
  onResize(event: Event): void {
    this.checkScreenSize();
  }

  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    this.checkScreenSize();
  }

  getTimeDifference(
    startTime: string | undefined,
    endTime: string | undefined
  ) {
    const hourDiff =
      Number(endTime?.toString().slice(8, 10)) -
      Number(startTime?.toString().slice(8, 10));
    const minDiff =
      Number(endTime?.toString().slice(10, 12)) -
      Number(startTime?.toString().slice(10, 12));
    return `${minDiff > 0 ? hourDiff : hourDiff - 1}hrs ${
      minDiff > 0 ? minDiff : 60 - Math.abs(minDiff)
    }mins`;
  }

  checkScreenSize(): void {
    this.isMobile = window.innerWidth < 768;
  }

  onDownload() {
    const content: any = this.content?.nativeElement;
    // const contentid = document.getElementById('content')
    // var HTML_Width = contentid?.width();
    // var HTML_Height = contentid?.height();
    // var top_left_margin = 15;
    // var PDF_Width = HTML_Width + top_left_margin * 2;
    // var PDF_Height = PDF_Width * 1.5 + top_left_margin * 2;
    // var canvas_image_width = HTML_Width;
    // var canvas_image_height = HTML_Height;

    // var totalPDFPages = Math.ceil(HTML_Height / PDF_Height) - 1;

    html2canvas(content, { allowTaint: true }).then((canvas) => {
      canvas.getContext('2d');
      let contentDataURL: any = canvas.toDataURL('image/png', 1.0);
      if (this.isMobile) {
        let pdf = new jsPDF('p', 'cm', 'a4');
        var width = pdf.internal.pageSize.getWidth();
        var height = pdf.internal.pageSize.getHeight();
        pdf.addImage(contentDataURL, 'PNG', 0, 0, width, height);
        pdf.save('ticket.pdf');
      } else {
        let pdf = new jsPDF({
          orientation: 'landscape',
          unit: 'cm',
          format: 'a4',
        });
        var width = pdf.internal.pageSize.getWidth();
        var height = pdf.internal.pageSize.getHeight();
        pdf.addImage(contentDataURL, 'PNG', 0, 0, width - 1, height - 6);
        pdf.save('ticket.pdf');
      }
    });
  }
}
